import React, { useEffect } from 'react';
import PlanetScene from './components/PlanetScene';
import Hud from './components/Hud';
import LiveChatDock from './components/LiveChatDock';
import AvatarChatDock from './components/AvatarChatDock';
import PerformToggle from './components/PerformToggle';
import RoutesPanel from './components/RoutesPanel';
import NpcPlacePanel from './components/NpcPlacePanel';
import CarSizePanel from './components/CarSizePanel';
import PerformerPanel from './components/PerformerPanel';
import GuardPanel from './components/GuardPanel';
import AdminPanel from './components/AdminPanel';
import DjBillboardHost from './components/DjBillboardHost';
import { useWorldStore } from './state/worldStore';
import { onNowPlaying } from './services/audioEngine';

export default function App() {
  const setNowPlaying = useWorldStore((s) => s.setNowPlaying);

  // ?fresh=1 — one-shot clean slate: wipe every locally-saved tuning override
  // (camera configs, panel placements) so the world boots purely from
  // rooms.js + manifests. The escape hatch when saved states conflict.
  useEffect(() => {
    if (new URLSearchParams(window.location.search).get('fresh')) {
      const wiped = Object.keys(localStorage).filter((k) => k.startsWith('orbit:') || k.startsWith('videoPanel:') || k.startsWith('bb:') || k.startsWith('route:') || k.startsWith('npcpos:'));
      wiped.forEach((k) => localStorage.removeItem(k));
      console.log(`[world] fresh boot — cleared ${wiped.length} saved override(s):`, wiped);
    }
  }, []);

  useEffect(() => {
    // Feed live now-playing into the world store (drives ticker + modulation pulls).
    const off = onNowPlaying((np) => setNowPlaying(np));
    return off;
  }, [setNowPlaying]);

  return (
    <>
      <PlanetScene />
      <Hud />
      {/* Live Anam call dock — DOM overlay; the stream itself lands on the
          room's 3D video card via worldStore.liveVideoEl. */}
      <LiveChatDock />
      {/* Voice chat with a clicked 3D resident (push-to-talk; the character
          body-animates while speaking via talkBridge). */}
      <AvatarChatDock />
      {/* SPIKE (?face=1): webcam → live head pose on the resident (faceBridge). */}
      <PerformToggle />
      {/* World tuning tools — all driven by one hub (AdminPanel ⚙, admins only).
          Each self-shows when its adminTool is active; only one at a time. */}
      <AdminPanel />
      <RoutesPanel />
      <NpcPlacePanel />
      <CarSizePanel />
      <PerformerPanel />
      <GuardPanel />
      {/* Radio DJ video-host cameo — the DJ speaks on the big billboards for
          dynamic moments (hidden stream video lives here; ?dj shows chrome). */}
      <DjBillboardHost />
    </>
  );
}